import { uniqueId } from 'lodash';
import { ALL_SOCIAL_PLATFORMS, INSTAGRAM_CONTENT_TYPES } from '~/constants';
import { ASSET_TYPE } from '~/searchApi';
import { ICreator } from '~/types';

import { ICreatorPlatformStatusValue } from './clientApi';

export interface ICreatorMockData {
  age: number;
  avatar: string;
  bio: string;
  category: string;
  gender: 'Female' | 'Male' | 'Non Binary';
  fullName: string;
  city: string;
  status: ICreatorPlatformStatusValue;
  platform: {
    instagram?: {
      followersCount: number;
      handle: string;
    };
    tiktok?: {
      followersCount: number;
      handle: string;
    };
    youtube?: {
      followersCount: number;
      handle: string;
    };
    snapchat?: {
      followersCount: number;
      handle: string;
    };
  };
  weblink?: string[];
  contentAgencyMockPost: string[];
  slug?: string;
}
export const createMockCreator = (
  mockCreators: ICreatorMockData[],
): ICreator[] => {
  // @ts-ignore too many type inconsistencies
  return mockCreators.map((creator) => ({
    age: creator.age,
    avatar: creator.avatar,
    belongsToSameAgency: false,
    benchmark: {
      id: uniqueId(),
    },
    bioAgency: creator.bio,
    categoryAgency: creator.category,
    email: 'victor12345@gmail.com',
    slug: creator.slug,
    status: 'connected',
    echoWelcomeSeen: true,
    genderAgency: creator.gender,
    fullName: creator.fullName,
    id: uniqueId(),
    city: creator.city,
    platforms: {
      instagram: {
        avatar: creator.avatar,
        followersCount: creator.platform?.instagram?.followersCount,
        handle: creator.platform?.instagram?.handle,
        isConnected: false,
        isTokenValid: false,
        name: creator.fullName,
        reminderSentCount: 0,
        shouldReAuth: false,
        status: creator.platform.instagram?.followersCount
          ? 'off-platform'
          : 'disconnected',
      },
      snapchat: {
        followersCount: creator.platform?.snapchat?.followersCount,
        handle: creator.platform?.snapchat?.handle,
        isConnected: false,
        isTokenValid: false,
        name: creator.fullName,
        reminderSentCount: 0,
        shouldReAuth: false,
        status: creator.platform.snapchat?.followersCount
          ? 'off-platform'
          : 'disconnected',
      },
      tiktok: {
        followersCount: creator.platform?.tiktok?.followersCount,
        handle: creator.platform?.tiktok?.handle,
        isConnected: false,
        isTokenValid: false,
        name: creator.fullName,
        reminderSentCount: 0,
        shouldReAuth: false,
        status: creator.platform.tiktok?.followersCount
          ? 'off-platform'
          : 'disconnected',
      },
      youtube: {
        followersCount: creator.platform?.youtube?.followersCount,
        handle: creator.platform?.youtube?.handle,
        isConnected: false,
        isTokenValid: false,
        name: creator.fullName,
        reminderSentCount: 0,
        shouldReAuth: false,
        status: creator.platform.youtube?.followersCount
          ? 'off-platform'
          : 'disconnected',
      },
    },
    totalAudience: 35503441,
    webLinks: creator.weblink || [],
    biography: '',
    echoWebStatus: null,
    contentAgencySelected: creator.contentAgencyMockPost.map((post) => ({
      assets: [
        {
          previewUrl: post,
          type: ASSET_TYPE.image,
          url: post,
        },
      ],
      caption: '',
      comments: 0,
      contentId: uniqueId(),
      createdTime: '2020-05-05T08:05:20.000+00:00',
      channel: INSTAGRAM_CONTENT_TYPES.post,
      creator: {
        firstName: 'Testing',
        lastName: 'Accountssss',
        id: uniqueId(),
        name: creator.fullName,
        platforms: {
          instagram: {
            handle: creator.platform?.instagram?.handle,
          },
          tiktok: {
            handle: creator.platform?.tiktok?.handle,
          },
          youtube: {
            handle: 'Whalar',
          },
        },
      },
      engagements: 0,
      impressions: 0,
      interactions: 0,
      likes: 0,
      platform: ALL_SOCIAL_PLATFORMS.instagram,
      publishedAt: '',
      shares: 0,
      type: ASSET_TYPE.image,
      updatedAt: '',
      plays: 0,
      reach: 0,
      views: 0,
      postFollowersEngRate: 0,
      postReachEngRate: 0,
      saved: 0,
      postedAt: '0',
    })),
  }));
};
